module.exports = __webpack_public_path__ + "media/login-page-bg-rzd-1920.3962e9a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-page-bg-rzd-1920.jpg
// module id = 1109
// module chunks = 62